import { configureStore } from '@reduxjs/toolkit';

import thunkMiddleware from 'redux-thunk';

import { kenoStoreSlice } from './kenoStoreSlice';
import { lotteryStoreSlice } from './lotteryStoreSlice';
import { soccerStoreSlice } from './soccerStoreSlice';
import { storeSlice } from './storeSlice';
import UserSlice from '../../../Store/Slicers/UserSlice';

const store = configureStore({
    reducer: {
        playStore: storeSlice.reducer,
        soccerPlayStore: soccerStoreSlice.reducer,
        kenoPlayStore: kenoStoreSlice.reducer,
        lotteryPlayStore: lotteryStoreSlice.reducer,
        user: UserSlice, // NOTE: this is duplicate from gglotto/resources/js/Store/GlobalStore.ts
    },
    middleware: [thunkMiddleware],
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
